import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=a2d1367a&"
import script from "./Duration.vue?vue&type=script&lang=ts&"
export * from "./Duration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports